import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { observer } from 'mobx-react';
import './styles.less';

import { useRootStore } from '../../store/RootStateContext';
import { useEffect } from 'react';

const StatusSecurity = () => {
  const { authStore, callsStats, socket } = useRootStore();

  const primarySecurityName = callsStats.primarySecurity.name || '-';

  const info = (
    <>
      <FormattedMessage id="statusSecutiry.primary" />{' '}
      {primarySecurityName}
    </>
  );

  const infoWithLink = (data) => {
    if (authStore.isSuperUser) return <span>{data}</span>;
    return <Link to="/app/settings">{data}</Link>;
  };

  useEffect(() => {
    if (socket && socket.connection && socket.connection.readyState === WebSocket.OPEN) {
      callsStats.getCallsStats();
    }
  }, [callsStats, socket])

  if (callsStats.isLoading) {
    return (
      <div className="statusSecurity">
        <LoadingOutlined spin />
      </div>
    );
  }

  return (
    <div className="statusSecurity">
      {infoWithLink(info)}
    </div>
  );
};

export default observer(StatusSecurity);
